import { QuestionStatus } from '@exam-management/graphql';

export const VIEWABLE_P_USE_STATUSES = [
  QuestionStatus.Draft,
  QuestionStatus.Published,
  QuestionStatus.Unpublished,
  QuestionStatus.Disabled,
];

export const VIEWABLE_B_INDEX_STATUSES = [
  QuestionStatus.Draft,
  QuestionStatus.Published,
  QuestionStatus.Unpublished,
  QuestionStatus.Disabled,
];
